import { z } from "zod";

import { defaultUrl, urlSchema } from "../shared";
import { customFieldSchema } from "./custom";
defaultUrl.label = "Mybharat Link";
// Schema
export const basicsSchema = z.object({
  name: z.string(),
  headline: z.string().max(100),
  client_id: z.string(),
  email: z.string(),
  phone: z.string().max(10, { message: "phone number should be of 10 digits" }),
  location: z.string(),
  url: urlSchema,
  logoFlag: z.boolean().default(false),
  rewardPoints: z.number().default(0),
  customFields: z.array(customFieldSchema),
  picture: z.object({
    url: z.string(),
    size: z.number().default(64),
    aspectRatio: z.number().default(1),
    borderRadius: z.number().default(0),
    effects: z.object({
      hidden: z.boolean().default(false),
      border: z.boolean().default(false),
      grayscale: z.boolean().default(false),
    }),
  }),
});
basicsSchema.required({
  headline: true,
});

// Type
export type Basics = z.infer<typeof basicsSchema>;

// Defaults
export const defaultBasics: Basics = {
  name: "",
  headline: "",
  client_id: "",
  email: "",
  phone: "",
  location: "",
  url: defaultUrl,
  logoFlag: false,
  rewardPoints: 0,
  customFields: [],
  picture: {
    url: "",
    size: 64,
    aspectRatio: 1,
    borderRadius: 0,
    effects: {
      hidden: false,
      border: false,
      grayscale: false,
    },
  },
};

export * from "./custom";
